import React from 'react';

export default function Spinner() {
  return (
    <div className="text-center mt40 mb40">
      <i
        className="fa fa-spinner fa-spin"
        style={{ fontSize: '4em' }}
      />
    </div>
  );
}
